var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home_page",attrs:{"id":"app"}},[_c('HeaderComponent'),_c('div',{staticClass:"gap"},[_c('ProfileComponents')],1),_c('FooterComponents',{staticClass:"m-t-100"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }